"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarItemStyled = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      borderRadius: '0rem 0.75rem 0.75rem 0rem',
      '& .MuiListItemIcon-root': {
        // color: theme.palette.secondary.light,
        minWidth: '2.25rem'
      },
      '&.Mui-selected:hover, &$selected': {
        backgroundColor: theme.palette.primary.main // color: theme.palette.text.white,
        // '& .MuiSvgIcon-root': {
        //   color: theme.palette.text.white,
        // },

      },
      '&:hover': {
        backgroundColor: theme.palette.primary.light // color: theme.palette.text.white,
        // '& .MuiSvgIcon-root': {
        //   color: theme.palette.text.white,
        // },

      },
      boxSizing: 'content-box',
      cursor: 'pointer',
      marginBottom: '0.1875rem',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: 'auto',
      textDecoration: 'none' // color: theme.palette.text.white,

    },
    selected: {
      backgroundColor: theme.palette.primary.main
    }
  };
})(_ListItem.default);
var _default = NavbarItemStyled;
exports.default = _default;